var map = {
	"./add.svg": "ebda806a5d",
	"./back.svg": "599ec88368",
	"./calendly.svg": "f9acd025e0",
	"./cities.svg": "189600dae9",
	"./clutch.svg": "f4c33ada80",
	"./countries.svg": "2f040d0955",
	"./footer-facebook.svg": "7d4aedf268",
	"./footer-github.svg": "d1ab24b308",
	"./footer-linkedin.svg": "b78c74e684",
	"./github.svg": "90e4cf4c41",
	"./linkedin.svg": "139d9ac5bd",
	"./mail.svg": "e67baa9966",
	"./nu.svg": "e4c2c1bde0",
	"./pdf.svg": "f98f5fe8eb",
	"./presentation.svg": "a46e5d42e0",
	"./quote.svg": "c72f432dd5",
	"./readmore.svg": "c9c9b3248e",
	"./speakers.svg": "cbd406a8f7",
	"./talks-github.svg": "464969c8b0",
	"./talks-twitter.svg": "3f10347832",
	"./twitter.svg": "5c0fc5ff81",
	"./views.svg": "4299c716d3",
	"./youtube.svg": "20fc6cce90"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d62b10df78";